import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

import { PlatformNegativeInvoiceGroupsListSkeleton } from '../../../../components/pages/backoffice/platform/platform-invoicing-negative-invoices-list/platform-invoicing-negative-invoices-list-skeleton.tsx'
import { PlatformNegativeInvoiceGroupsList } from '../../../../components/pages/backoffice/platform/platform-invoicing-negative-invoices-list/platform-invoicing-negative-invoices-list.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/invoicing/negative-invoices')({
  component: () => (
    <PermissionChecker requiredPermissions={['invoice.configuration']}>
      <Suspense fallback={<PlatformNegativeInvoiceGroupsListSkeleton />}>
        <PlatformNegativeInvoiceGroupsList />
      </Suspense>
    </PermissionChecker>
  ),
})
